import { ErrorHandler, Injectable } from '@angular/core';
import { FiLogErrorService } from '@fi-shared/fi-shared-services/fi-log-error.service';

@Injectable()
export class FiErrorHandler implements ErrorHandler {
    constructor(private logErrorService: FiLogErrorService) {}
    handleError(exception) {
        this.logErrorService.logError(exception);
    }
}
